var _rect, _rect2, _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTaskIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 32,
    height: 32,
    rx: 16,
    fill: "#F4EBFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2,
    y: 2,
    width: 32,
    height: 32,
    rx: 16,
    stroke: "#F9F5FF",
    strokeWidth: 4
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.6365 11.4531H24.7637C24.8988 11.4531 25.0283 11.5106 25.1237 11.6129C25.2192 11.7152 25.2728 11.8539 25.2728 11.9986V21.6349",
    stroke: "#7F56D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.1819 20.0423V14.8918C12.1819 14.7526 12.2328 14.6192 12.3236 14.5208C12.4143 14.4225 12.5373 14.3672 12.6656 14.3672H21.88C22.0083 14.3672 22.1313 14.4225 22.222 14.5208C22.3127 14.6192 22.3637 14.7526 22.3637 14.8918V24.0244C22.3637 24.1635 22.3127 24.297 22.222 24.3954C22.1313 24.4937 22.0083 24.549 21.88 24.549H17.0191",
    stroke: "#7F56D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.2727 20.9141L12.9091 24.5504L10.7273 22.7322",
    stroke: "#7F56D9",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaskIcon);
export default __webpack_public_path__ + "static/media/task-icon.5ca38023ed0fb672883ecfd15bddfea4.svg";
export { ForwardRef as ReactComponent };